import {MatchResource} from "../resource/MatchResource";
import {Match} from "../league/Match";
import {IApiMatch, IApiMatchResultReportRound, IApiMatchResultReport, IApiMatchMedia} from "../typings/apiResponse";
import {MatchResultReport} from "../league/MatchResultReport";
import {MatchQuery} from "../resource/MatchQuery";
import * as angular from "angular";

export class MatchService {

    public static $inject = ["MatchResource"];
    constructor(private MatchResource: MatchResource) {}

    public getMatch(id: number): angular.IPromise<Match> {
        return this.MatchResource.getMatch(id).then(
            (apiMatch: IApiMatch) => {
                if (!apiMatch){
                    return null;
                }

                return new Match(apiMatch);
            }
        );
    }

    public getMatchesForLeague(id: number): angular.IPromise<Array<Match>> {
        return this.MatchResource.getMatchesForLeague(id).then(function(apiMatches: Array<IApiMatch>) {
            var tempMatches: Array<Match> = [];

            angular.forEach(apiMatches, (match: IApiMatch) => {
                tempMatches.push(new Match(match));
            });

            return tempMatches;
        });
    }

    public getMatchesInRound(id: number, round:number): angular.IPromise<Array<Match>> {
        return this.MatchResource.getMatchesInRound(id, round).then(function(apiMatches: Array<IApiMatch>) {
            var tempMatches: Array<Match> = [];

            angular.forEach(apiMatches, (match: IApiMatch) => {
                tempMatches.push(new Match(match));
            });

            return tempMatches;
        });
    }

    public getMatchesForLoggedInUser(matchQuery: MatchQuery): angular.IPromise<Array<Match>> {
        return this.MatchResource.getMatchesForLoggedInUser(matchQuery).then(
            (apiMatches: Array<IApiMatch>) => {
                var tempMatches: Array<Match> = [];

                angular.forEach(apiMatches, (match: IApiMatch) => {
                    tempMatches.push(new Match(match));
                });

                return tempMatches;
            }
        );
    }

    public getMatchResultReport(matchId: number): angular.IPromise<MatchResultReport> {
        return this.MatchResource.getMatchResultReport(matchId).then(
            (matchResultReport: IApiMatchResultReport) => {
                return new MatchResultReport(matchResultReport);
            }
        );
    }

    public reportResultForMatch(matchId: number, rounds: IApiMatchResultReportRound[], opponentAbsent: boolean = false): angular.IPromise<Match> {
        // Best of three needs a third map set
        if (rounds.length > 2 && !rounds[2].map) {
            rounds[2].map = ' ';
        }

        return this.MatchResource.postMatchResultReport(matchId, rounds, opponentAbsent).then(
            (matchData: IApiMatch) => {
                return new Match(matchData);
            }
        );
    }

    public reportOpponentAbsent(matchId: number): angular.IPromise<Match> {
        return this.MatchResource.getMatchResultReport(matchId).then(
            (matchResultReport: IApiMatchResultReport) => {
                return this.reportResultForMatch(matchId, matchResultReport.rounds, true);
            }
        );
    }

    public acceptOpponentResult(matchId: number): angular.IPromise<Match> {
        return this.MatchResource.getMatchResultReport(matchId).then(
            (matchResultReport: IApiMatchResultReport) => {
                return this.reportResultForMatch(matchId, matchResultReport.rounds, matchResultReport.contestants.opponent.absent);
            }
        );
    }

    public uploadMatchmedia(matchId: number, file: File): angular.IPromise<boolean> {
        return this.MatchResource.uploadMatchmedia(matchId, file);
    }

    public getMatchmedia(matchId: number): angular.IPromise<IApiMatchMedia[]> {
        return this.MatchResource.getMatchmedia(matchId);
    }

    public compareMatchesByBeginAt(matchA: Match, matchB: Match): number {
        return matchA.getBeginAt().getTime() - matchB.getBeginAt().getTime();
    }

    public compareMatchesByCalculatedAt(matchA: Match, matchB: Match): number {
        return matchA.getCalculatedAt().getTime() - matchB.getCalculatedAt().getTime();
    }

    /**
     * Get all valid bestOf values for given bestOf parameter.
     *
     * @param bestOf  The bestOf parameter.
     * @param draw    Specify as false to exclude draw values.
     *
     * @returns array of strings, example bo3: ['2:0', '2:1'].
     */
    public getValidBestOfValues(bestOf: number, draw: boolean = true): string[] {
        const validScores: string[] = [];
        let winningScore: number;

        if (bestOf % 2 === 0) {
            winningScore = (bestOf / 2) + 1;

            if (draw) {
                const halfBestOf = bestOf / 2;
                // add draw
                validScores.push(`${halfBestOf}:${halfBestOf}`);
            }
        } else {
            winningScore = (bestOf + 1) / 2;
        }

        for (let i = 0; i <= (bestOf - winningScore); i++) {
            validScores.push(`${winningScore}:${i}`);
        }

        return validScores;
    }
}
